/* Libraries */
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';

/* Store */
import { useChatStoreActions } from '@store/client/store.chat';

/* Components */
import Header from './components/Header/HomeHub.Header';
import Footer from './components/Footer/HomeHub.Footer';
import ChatComponent from '@integrations/gladly/Chat/Gladly.Component';
import Snackbar from '@components/UI/Snackbar';

import { COMPONENT_POSITION } from 'types/component.types';
import styles from './homeHub.module.scss';

/* Home Hub Specific Layout Concerns */
type TLayoutProps = {
  suppressFooter?: boolean;
};

const getLayout =
  ({ suppressFooter }: TLayoutProps = { suppressFooter: false }) =>
  (page: $FixMe) => {
    const { setRenderDesktopAsMobile } = useChatStoreActions();
    const router = useRouter();

    useEffect(() => {
      setRenderDesktopAsMobile(true);
    }, [setRenderDesktopAsMobile]);

    if (!router.isReady) return null;
    const isRecommendationsPage = router.route.indexOf('recommendations') > -1;

    return (
      <div className={classNames(styles.homehub_layout, !isRecommendationsPage ? styles.overflow : '')}>
        <Snackbar type={COMPONENT_POSITION.fixed} />
        <Header />
        {page}
        <Snackbar />
        {!suppressFooter && <Footer />}
        <ChatComponent />
      </div>
    );
  };

export default getLayout;
